import React from "react"
import { ProgressBar } from "packages/ui-shared/components/ProgressBar/ProgressBar"
import { text, bannerWrapper } from "./ProgressBanner.css"

type Props = {
  progressBannerCopy: string
  percentProgress: string
  styles?: string
  type?: string
}

const ProgressBarAriaLabelMap = {
  EXPRESS_SHIPPING: "Express shipping progress bar",
  GWP: "Gift with purchase progress bar",
  SAMPLES: "Samples progress bar",
  STANDARD_SHIPPING: "Standard shipping progress bar",
}

export const ProgressBanner: React.FC<Props> = ({
  progressBannerCopy,
  percentProgress,
  styles = "",
  type,
}) => {
  return (
    <div className={`${styles} ${bannerWrapper}`} data-testid="progress-banner">
      <span className={text}>{progressBannerCopy}</span>
      <ProgressBar
        percentProgress={percentProgress}
        ariaLabel={type ? ProgressBarAriaLabelMap[type] : "Progress bar"}
      />
    </div>
  )
}
